import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
class GetTotalResultsAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {GetSearchResultsAdsService} deps.getSearchResultsAdsService
   */
  constructor({config, service}) {
    super({config, service})
    this._config = config
    this._searchResultsAdsService = service
  }

  @tracer({metric: 'GetTotalResultsAdsUseCase#execute'})
  @inlineError
  async execute(params = {}) {
    const [getSearchResultsServiceError, getSearchResultsServiceResponse] = await this._searchResultsAdsService.execute(
      params
    )
    if (getSearchResultsServiceError) return Promise.reject(getSearchResultsServiceError)
    const {totalResults} = getSearchResultsServiceResponse.toJSON()
    return {totalResults}
  }
}

export default GetTotalResultsAdsUseCase
